export enum GroupSearchOrder {
  OrderByGroupId = 1,
  OrderByName = 2,
  OrderByCreationDateTime = 3,
}
